<template>
  <a-divider>无归属列表切换</a-divider>
  <!--  // 当前模式-->
  <div style="width: 100%;display: flex;justify-content: center;padding: 10px 0;align-items: center">
    <a-space>
      当前模式:
      <a-select
          ref="select"
          v-model:value="currentModal"
          style="width: 120px"
      >
        <a-select-option value="tagList">标签列表</a-select-option>
        <a-select-option value="noHomeDevice">无归属设备</a-select-option>
      </a-select>
    </a-space>
  </div>
  <tag-list v-if="currentModal === 'tagList'"/>
  <no-tag-list v-else/>
</template>

<script setup>
import TagList from "@/layouts/admin-sidebar/tag/list/tag-list.vue";
import noTagList from "@/layouts/admin-sidebar/tag/noTagList/index.vue";
import tagData from "@/layouts/admin-sidebar/tag/tagData";

let {
  currentModal
} = tagData();
</script>
<style scoped lang="scss">

</style>
